import { height } from '@mui/system';
import { useTheme } from 'styled-components';
import { shadowColor } from 'theme/color';
import { poppins300 } from 'theme/common.style';

export const activityCont = {
  borderRadius: '5px',
  border: '0.5px solid #D9D9D9',

  padding: '14px',
  height: '100%',
  overflow: 'scroll',
  marginBottom: '0px',
};
export const displayFlex = {
  display: 'flex',
  flexDirection: 'column !important',
};

export const BuyerCheckLbl = {
  fontSize: '12px',
  fontFamily: 'poppins',
  fontWeight: 400,
};

export const circleCont = {
  borderRadius: '50%',
  display: 'flex',
  padding: '5px',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#FFFFFF',
  boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.15)',
};

export const labelCont = {
  textAlign: 'center',
  margin: '20px',
  ...poppins300,
};
export const displayFlexRow = {
  display: 'flex',
  flexDirection: 'row',
};
export const imageCont = {
  ...displayFlexRow,
  alignItems: 'center',
  width: '100%',
};
export const userDetCont = {
  paddingLeft: '20px',
  height: '100%',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  border: 'none',
  width: '100%',
};
